import { all } from 'redux-saga/effects'
import { authSaga, diagnosticSaga, pincodeSaga, foodscanSaga } from './sagas'

export default function* rootSaga() {
  yield all([authSaga(), diagnosticSaga(), pincodeSaga(), foodscanSaga()])
}
